import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";
import QzTrayCertificateGeneratorCard from "../../components/qztray/generateCertificate/QzTrayCertificateGeneratorCard";
import QzTrayCertificateInformation from "../../components/qztray/generateCertificate/QzTrayCertificateInformation";


const QzTrayGenerateCertificate = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <div className="space-y-6">
          <QzTrayCertificateGeneratorCard />

          <QzTrayCertificateInformation />
        </div>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default QzTrayGenerateCertificate;